<template>
  <div class="loadingAll">
    <div class='wrapper'>
      <div class='loading'>
            <span
              :style='{
                width: "20px",
                animationDuration: duration.indexOf("s") === -1 ? duration + "s" : duration ,
                animationDelay: parseInt(duration)/text.length*index +"s"
              }'
              v-for='char,index in text'>
              {{char}}
            </span>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
        props: {
          text:{
            type:String,
            default:'智慧冷链平台'//默认1s
          },
          duration:{
            type:String,
            default:'1s'//默认1s
          }
        },
        name: "loading",
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {


        }
    }
</script>

<style scoped>
  .loadingAll{
  }
  .wrapper{
    position: fixed;
    top: 50%;
    left: 50%;
    z-index:9999;
    display: flex;
    justify-content: center;
  }
  .loading {
    display: flex;
    text-align: center;
    padding-top: 30px;
    height: 50px;
    justify-content: space-between;
  }
  .loading span {
    margin: 0 5px;
    color: #3a8ee6;
    margin-top: 0;
    animation: ease infinite move;
    display: block;
  }

  @keyframes move {
    0% {
      margin-top: -10px;
      /*border-bottom: 1px solid #3a8ee6;*/
    }
    50% {
      margin-top: 10px;
      border-bottom: none;
    }
    100% {
      margin-top: -10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/design/Loading.vue